import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../../common/constant";

// Custom Previous Arrow
const PrevArrow = ({ onClick }) => (
    <div
        onClick={onClick}
        className="absolute top-1/2 -left-6 transform -translate-y-1/2 cursor-pointer bg-[#54BD95] text-white p-2 rounded-full shadow-lg"
    >
        <ChevronLeft size={20} />
    </div>
);

// Custom Next Arrow
const NextArrow = ({ onClick }) => (
    <div
        onClick={onClick}
        className="absolute top-1/2 -right-6 transform -translate-y-1/2 cursor-pointer bg-[#54BD95] text-white p-2 rounded-full shadow-lg"
    >
        <ChevronRight size={20} />
    </div>
);

const BlogSlider = () => {
    const navigate = useNavigate();
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchBlogs = async () => {
            try {
                const response = await axios.get(`${API_URL}/api/blog/blogs`); // Replace with your blog API endpoint
                setBlogs(response.data.blogs.slice(0, 5)); // Get first 5 blogs
                setLoading(false);
            } catch (error) {
                console.error("Error fetching blogs:", error);
                setLoading(false);
            }
        };
        fetchBlogs();
    }, []);

    const settings = {
        dots: false,
        infinite: blogs.length > 1, // Prevent infinite loop if there's only 1 blog
        speed: 100,
        autoplay: blogs.length > 1, // Autoplay only if multiple blogs exist
        slidesToShow: Math.min(blogs.length, 3), // Show only available blogs (max 3)
        slidesToScroll: 1,
        nextArrow: blogs.length > 1 ? <NextArrow /> : null, // Hide arrows if only 1 blog
        prevArrow: blogs.length > 1 ? <PrevArrow /> : null, // Hide arrows if only 1 blog
        responsive: [
            { breakpoint: 1024, settings: { slidesToShow: Math.min(blogs.length, 2) } },
            { breakpoint: 768, settings: { slidesToShow: Math.min(blogs.length, 1) } },
        ],
    };


    if (loading) return <p className="text-center text-gray-600">Loading blogs...</p>;

    return (
        <div className="mt-6 ">
            {/* Heading and Show More Button */}
            <div className="flex flex-col items-center text-center px-4">
                <h2 className="text-2xl sm:text-3xl md:text-4xl  text-[#54BD95] mt-4">
                    Latest Blogs and Articles
                </h2>
            </div>
            <div className="flex justify-end px-4">
                <Link to="/allBlogs">
                    <p className="text-[#59bd95]  text-xl mt-2 font-bold">{'More Blogs-->'}</p>
                </Link>
            </div>


            {/* Blog Slider */}
            <div className="relative px-4 mt-6">
                {blogs.length > 0 ? (
                    <Slider {...settings}>
                        {blogs.map((blog) => (
                            <div key={blog._id} className="p-4">
                                <div
                                    className="bg-white shadow-lg rounded-lg overflow-hidden flex flex-col md:flex-row items-center md:items-start transition-transform transform hover:scale-[1.02] hover:shadow-xl cursor-pointer"
                                    onClick={() => navigate(`/blog/${blog.slug}`)}
                                >
                                    {/* Left - Blog Image */}
                                    <div className="w-full md:w-1/3 relative">
                                        <img
                                            src={`${API_URL}/uploads/blogs/${blog._id}/${blog.featureImages[0]}`}
                                            alt={blog.title}
                                            className="w-full h-52 md:h-44 object-cover"
                                        />
                                        <div className="absolute inset-0 bg-black bg-opacity-10 rounded-l-lg"></div>
                                    </div>

                                    {/* Right - Blog Content */}
                                    <div className="w-full md:w-2/3 p-5">
                                        {/* Title */}
                                        <h2 className="text-lg font-semibold text-gray-900 hover:text-[#54BD95] transition-all duration-300">
                                            {blog.title}
                                        </h2>

                                        {/* Blog Date & Author */}
                                        <p className="text-sm text-gray-500 mt-2">
                                            {new Date(blog.createdAt).toLocaleDateString()} |
                                            <span className="text-[#54BD95] font-medium"> By Placezio Estate</span>
                                        </p>

                                        {/* Read More Button */}
                                        <p
                                            onClick={() => navigate(`/blog/${blog.slug}`)}
                                            className="mt-4 inline-block bg-[#54BD95] text-white px-4 py-2 rounded-md font-medium text-sm hover:bg-[#3a8f70] transition-all duration-200"
                                        >
                                            Read Full Blog →
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))}

                    </Slider>
                ) : (
                    <p className="text-center text-lg text-gray-500">No blogs available.</p>
                )}
            </div>
        </div>
    );
};

export default BlogSlider;
